/**
 * Builds an inert document for user-supplied active content. The sandboxed
 * iframe receives no script permission, no origin, and no network capability.
 */
export function isolatedArtifactDocument(source: string): string {
  return `<!doctype html><html><head><meta charset="utf-8"><meta http-equiv="Content-Security-Policy" content="default-src 'none'; style-src 'unsafe-inline'; img-src data: blob:"><style>body{margin:0;padding:16px;font:14px/1.5 system-ui;color:#f1eae5;background:#262027;color-scheme:dark}img{max-width:100%}</style></head><body>${source}</body></html>`;
}

export function activeArtifacts(markdown: string): readonly string[] {
  return [...markdown.matchAll(/```artifact-html\s*\n([\s\S]*?)```/g)].map((match) => match[1] ?? "");
}

export function createIsolatedArtifact(source: string): HTMLIFrameElement {
  const frame = document.createElement("iframe");
  frame.className = "artifact-frame";
  frame.title = "Isolated artifact preview";
  frame.sandbox.value = "";
  frame.referrerPolicy = "no-referrer";
  frame.loading = "lazy";
  frame.srcdoc = isolatedArtifactDocument(source);
  return frame;
}
